"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResourcesComponent = /** @class */ (function () {
    function ResourcesComponent() {
    }
    return ResourcesComponent;
}());
exports.ResourcesComponent = ResourcesComponent;
